import { Box } from "@mui/material";
import { useParams } from "react-router";
import RoleModule from "./RoleModule";

function RoleModuleForm() {
    const { roleModuleId } = useParams();
    return (
        <Box>
            <RoleModule.Form baseSaveData={{
                RoleId: parseInt(roleModuleId)
            }} />
        </Box>
    );
}

export default RoleModuleForm;